import { render, staticRenderFns } from "./OptionAddCover.vue?vue&type=template&id=5c1b706c&scoped=true&"
import script from "./OptionAddCover.vue?vue&type=script&lang=ts&"
export * from "./OptionAddCover.vue?vue&type=script&lang=ts&"
import style0 from "./OptionAddCover.vue?vue&type=style&index=0&id=5c1b706c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b706c",
  null
  
)

export default component.exports